export default function ReviewListSkeleton() {
	return (
		<div className="space-y-4">
			{Array.from({ length: 5 }).map((_, index) => (
				<div key={index} className="p-4 bg-white border border-gray-200 rounded-lg animate-pulse">
					<div className="h-5 bg-gray-200 rounded w-1/4 mb-4" />
					<div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
					<div className="h-4 bg-gray-200 rounded w-full mb-2" />
					<div className="h-4 bg-gray-200 rounded w-5/6" />
				</div>
			))}
		</div>
	);
}
